export const imprintTemplate = `
<div class="container">
  <p>
    <b>Angaben gemäß § 5 TMG:</b><br/>
    scitis.io GmbH<br/>
    Seyfferstr. 34<br/>
    70197 Stuttgart<br/>
    Vertreten durch Herrn Ralf Kölle<br/>
    <br/>
    <span translate>Phone</span>: +49 160 809 5000<br/>
    <span translate>Fax</span>: +49 160 809 5000<br/>
    E-Mail: info@scitis.io</p>
  <b translate>Court of Commercial Registration:</b> 70197 Stuttgart<br/>
  <b translate>Record Number:</b> HRB 758334<br/>
  <!--<b translate>VAT ID Number per Section 27a of the VAT Act:</b> DE 815381305<br/>-->
  <p>
    <br/>
    <b>scitis.io GmbH </b><b translate> is represented by its General Partner:</b><br/>
    Ralf Kölle<br/>
    Seyfferstr. 34<br/>
    70197 Stuttgart<br/>
  </p>
  <h2 class="section_head">
    <span class="title" translate>Privacy policy</span>
  </h2>
  <div class="row around-xs text">
    <div class="col-xs-12 col-md-10 col-lg-7">
      <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
        personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
        Datenschutzerklärung.</p>
      <p>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren
        Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt
        dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht
        an Dritte weitergegeben.</p>
      <p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
        Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
        möglich.</p>
    </div>
  </div>
</div>
`;
